var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3873 19.3607C25.7554 19.7532 25.7356 20.3699 25.343 20.738C19.4174 26.2947 10.1122 25.9918 4.55609 20.0668C4.18798 19.6742 4.20779 19.0576 4.60035 18.6894C4.99291 18.3213 5.60956 18.3411 5.97768 18.7337C10.7982 23.8743 18.87 24.1363 24.01 19.3164C24.4025 18.9483 25.0192 18.9681 25.3873 19.3607Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0402 18.8093C25.5755 18.8649 25.9643 19.3439 25.9086 19.8792L25.509 23.7239C25.4534 24.2592 24.9743 24.648 24.4391 24.5924C23.9038 24.5368 23.515 24.0577 23.5706 23.5225L23.9703 19.6777C24.0259 19.1425 24.5049 18.7536 25.0402 18.8093Z",
    fill: "#0F20E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9086 19.8814C25.8519 20.4166 25.3721 20.8044 24.8369 20.7477L21.1989 20.3619C20.6637 20.3051 20.2759 19.8253 20.3326 19.2901C20.3894 18.755 20.8692 18.3671 21.4044 18.4239L25.0424 18.8097C25.5776 18.8664 25.9654 19.3463 25.9086 19.8814Z",
    fill: "#0F20E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64797 12.3977C12.5737 6.84095 21.8788 7.1439 27.435 13.069C27.8031 13.4615 27.7833 14.0782 27.3907 14.4463C26.9982 14.8144 26.3815 14.7946 26.0134 14.402C21.1929 9.26146 13.121 8.99936 7.98104 13.8193C7.58848 14.1874 6.97183 14.1676 6.60372 13.775C6.2356 13.3824 6.25541 12.7658 6.64797 12.3977Z",
    fill: "#0F20E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55972 8.54951C8.09499 8.60514 8.48382 9.08417 8.42818 9.61944L8.02858 13.4641C7.97295 13.9994 7.49392 14.3882 6.95865 14.3326C6.42338 14.277 6.03455 13.7979 6.09019 13.2627L6.48979 9.41797C6.54542 8.8827 7.02445 8.49387 7.55972 8.54951Z",
    fill: "#0F20E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6598 13.8437C11.6039 14.3789 11.1247 14.7675 10.5895 14.7117L6.95832 14.3327C6.42307 14.2768 6.03445 13.7976 6.09032 13.2624C6.14619 12.7271 6.62538 12.3385 7.16063 12.3944L10.7918 12.7734C11.327 12.8292 11.7156 13.3084 11.6598 13.8437Z",
    fill: "#0F20E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.246 18.3167C15.2125 19.2833 16.7796 19.2833 17.7462 18.3168C18.7127 17.3502 18.7127 15.7831 17.7462 14.8165C16.7796 13.8499 15.2125 13.85 14.246 14.8165C13.2794 15.7831 13.2794 17.3502 14.246 18.3167Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.77b1eeb2ecf25af630733acb00a07b20.svg";
export { ForwardRef as ReactComponent };